import { all, takeEvery, put, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { login, fetchCurrentAccount, logout, newPasswordChallenge } from 'src/services/user';
import { actions } from './actions';

export function* LOGIN({
  payload,
}: {
  payload: { email: string; password: string };
}): SagaIterator {
  const { email, password } = payload;
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  });
  const success = yield call(login, email, password);
  console.log('LOGIN => ', success);
  if (success === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        newPassword: true,
        loading: false,
      },
    });
  } else {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    });
  }
}

export function* CHANGE_PASSWORD({ payload }: { payload: { newPassword: string } }): SagaIterator {
  const { newPassword } = payload;
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
      newPassword: false,
    },
  });
  const response = yield call(newPasswordChallenge, newPassword);
  console.log('NEW_PASSWORD_CHALLENGE() => ', response);
  if (response) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    });
  }
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  });
}

export function* LOAD_CURRENT_ACCOUNT(): SagaIterator {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  });
  const currentAccount = yield call(fetchCurrentAccount);
  console.log('LOAD_CURRENT_ACCOUNT() => ', currentAccount);
  if (currentAccount.success === true) {
    const {
      userAttributes: { uid: id, email, photoURL: avatar, email: name },
    } = currentAccount.response;
    let group = '';
    const groupName: string[] =
      currentAccount.response.session.tokens.accessToken.payload['cognito:groups'];
    if (groupName) {
      groupName.forEach((data) => {
        if (data === 'ADMIN') {
          group = data;
        }
      });
    }

    const payload = {
      id,
      name,
      email,
      avatar,
      role: group,
      authorized: true,
    };

    yield put({
      type: 'user/SET_STATE',
      payload,
    });
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  });
}

export function* LOGOUT(): SagaIterator {
  const logoutResponse = yield call(logout);
  console.log('LOGOUT => ', logoutResponse);
  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: '',
      email: '',
      avatar: '',
      authorized: false,
      loading: false,
      newPassword: false,
    },
  });
}

export const user = function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN as any, LOGIN),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.CHANGE_PASSWORD as any, CHANGE_PASSWORD),
    takeEvery(actions.LOGOUT, LOGOUT),
    LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ]);
};
